import { resolveThemeColor } from "@circleco/community-switcher/helpers/bgColor";
import { communitySwitcherInitials } from "@circleco/community-switcher/helpers/utils";
import { colord, extend } from "colord";
import a11yPlugin from "colord/plugins/a11y";

extend([a11yPlugin]);

interface DockCommunityAvatarProps {
  readonly darkBrandColor?: string;
  readonly iconUrl: string;
  readonly isDarkAppearance?: boolean;
  readonly lightBrandColor?: string;
  readonly name: string;
}

export const DockCommunityAvatar = ({
  iconUrl,
  name,
  isDarkAppearance = false,
  lightBrandColor,
  darkBrandColor,
}: DockCommunityAvatarProps) => {
  const bgColor = resolveThemeColor(
    lightBrandColor,
    darkBrandColor,
    isDarkAppearance,
  );
  const textColor =
    bgColor && colord(bgColor).luminance() > 0.65 ? "#000" : "#fff";

  return (
    <span
      aria-hidden
      className="flex size-6 shrink-0 select-none items-center justify-center overflow-hidden rounded-md"
    >
      {iconUrl ? (
        <img
          loading="lazy"
          alt={`${name} icon`}
          className="size-6 rounded-md object-cover"
          src={iconUrl}
        />
      ) : (
        <span
          className="flex size-6 items-center justify-center rounded-md text-sm font-bold leading-none"
          style={
            bgColor ? { backgroundColor: bgColor, color: textColor } : undefined
          }
        >
          {communitySwitcherInitials(name)}
        </span>
      )}
    </span>
  );
};
